import { useState } from 'react';
import { Button, Dropdown, Form, Spinner } from 'react-bootstrap';
import { Formik, Field } from 'formik';
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';

const ChangeRequestApprovalToggle = ({ status, onProcess }) => {
  const [isProcessing, setIsProcessing] = useState(false);
  if (status === 'approve') {
    return (
      <Button size="sm" variant="white" className="mt-2">
        <i className="mdi mdi-check-circle me-1 text-success" />
        Approved
      </Button>
    );
  }

  if (status === 'reject') {
    return (
      <Button size="sm" variant="white" className="mt-2">
        <i className="mdi mdi-close-circle me-1 text-danger" />
        Rejected
      </Button>
    );
  }

  return (
    <Dropdown>
      <Dropdown.Toggle
        as={Button}
        size="sm"
        variant="white"
        className="mt-2"
        to={{ hash: '#' }}
      >
        <i className="mdi mdi-check-circle me-1 text-warning" />
        Pending
      </Dropdown.Toggle>

      <Dropdown.Menu
        className="dropdown-menu-right p-3 mt-1"
        style={{ width: '300px' }}
        renderOnMount
        popperConfig={{ strategy: 'fixed' }}
      >
        <Formik
          initialValues={{ remarks: '' }}
          onSubmit={(values, { resetForm }) => {
            setIsProcessing(true);
            onProcess('approve', values.remarks);
            resetForm();
          }}
        >
          {(formikprops) => (
            <Form onSubmit={formikprops.handleSubmit}>
              {isProcessing ? (
                <div className="d-flex justify-content-center py-2">
                  <Spinner animation="border" size="sm" />
                </div>
              ) : (
                <>
                  <Form.Group controlId="approvalRemarks" className="mb-3">
                    <Field
                      as="textarea"
                      maxLength="300"
                      name="remarks"
                      rows="2"
                      className="form-control"
                      placeholder="Remarks"
                    />
                  </Form.Group>
                  <div className="d-flex justify-content-start">
                    <Button
                      variant="primary"
                      type="submit"
                      size="sm"
                      className="me-2"
                    >
                      Approve
                    </Button>
                    <Button
                      variant="white"
                      type="button"
                      size="sm"
                      onClick={() => {
                        if (formikprops.values.remarks.trim().length === 0) {
                          toast.error('Please enter a reason for rejection');
                          return;
                        }
                        setIsProcessing(true);
                        onProcess('reject', formikprops.values.remarks);
                      }}
                    >
                      Reject
                    </Button>
                  </div>
                </>
              )}
            </Form>
          )}
        </Formik>
      </Dropdown.Menu>
    </Dropdown>
  );
};

ChangeRequestApprovalToggle.propTypes = {
  status: PropTypes.string,
  onProcess: PropTypes.func,
};

export default ChangeRequestApprovalToggle;
